import { createSlice } from '@reduxjs/toolkit';

const institutions = createSlice({
  name: 'institutions',
  initialState: [],
  reducers: {
    setInstitutions(state, action) {
      return action.payload;
    }
  }
});

export const { setInstitutions } = institutions.actions;
export default institutions.reducer;